/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".calendar-container[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.time-slots-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:5px}.time-slot[_ngcontent-%COMP%]{flex-basis:25%;padding:6px;border:1px solid #ccc;border-radius:4px;cursor:pointer;margin-bottom:20px}.selected[_ngcontent-%COMP%]{background-color:#004aad;color:#fff;font-weight:700}.p-calendar[_ngcontent-%COMP%]   .p-datepicker-calendar[_ngcontent-%COMP%]   .p-day[_ngcontent-%COMP%], .p-calendar[_ngcontent-%COMP%]   .p-datepicker-calendar[_ngcontent-%COMP%]   .p-disabled[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };

